import React, { useState } from "react";
import "../../../../../Assets/Styles/JPADetailsModal.scss";

const JpaDetailsModal = (props) => {
  const [IsApplied, setIsApplied] = useState(props.jpaDetails.applied || !!props.jpaDetails.application?.id);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const shortenText = (Text, Length) => {
    if (Text !== undefined) {
      if (Text.length <= Length) {
        return Text;
      } else {
        let Short = Text.slice(0, Length - 4) + " ...";
        return (
          <>
            <p className="popup-text">{Text}</p>
            {Short}
          </>
        );
      }
    }
  };

  const toggleApply = (ApplicationType) => {
    props.Apply(ApplicationType);
    setIsApplied(true);
  };

  const displayID = () => {
    if (props.jpaDetails.globalPositionCode) {
      return ", ID:" + props.jpaDetails.globalPositionCode;
    } else if (props.jpaDetails.globalProjectCode) {
      return ", ID:" + props.jpaDetails.globalProjectCode;
    } else if (props.jpaDetails.globalActivityCode) {
      return ", ID:" + props.jpaDetails.globalActivityCode;
    }
  };

  return (
    <div className="details-overlay">
      <div className="outline" onClick={() => props.Close()}></div>
      <div className="details-modal">
        <section className="details-modal-head">
          <span>
            <h1>
              {props.jpaDetails
                ? shortenText(props.jpaDetails.title, 25)
                : null}
            </h1>
            <p>
              {props.jpaDetails
                ? shortenText(props.jpaDetails.workCity, 22)
                : null}
              {props.jpaDetails ? displayID() : null}
            </p>
          </span>
          <i className="feather-x" onClick={() => props.Close()}></i>
        </section>
        <section className="details-modal-body">
          <div className="details-info">
            <section className="info-row">
              <p className="details-info row-name">
                {translateText("description")}
              </p>
              <p className="details-info">
                {props.jpaDetails?.description ||
                  translateText("not_available")}
              </p>
            </section>
            <section className="info-row">
              <p className="details-info row-name">
                {translateText("years_of_experience")}
              </p>
              <p className="details-info">
                {props.jpaDetails?.yearsOfExperience ||
                  translateText("not_available")}
              </p>
            </section>
          </div>
          <section className="jpa-actions disabled-cancel">
            {IsApplied ? (
              <>
                <span className="disabled-apply-btn" onClick={() => null}>
                  {translateText("jpa_status_applied")}
                </span>
                <span className="disabled-apply-btn" onClick={() => null}>
                  {translateText("anonymous_apply")}
                </span>
              </>
            ) : (
              <>
                <span onClick={() => toggleApply(false)}>
                  {translateText("apply")}
                </span>
                <span onClick={() => toggleApply(true)}>
                  {translateText("anonymous_apply")}
                </span>
              </>
            )}
          </section>
        </section>
      </div>
    </div>
  );
};

export default JpaDetailsModal;
